import {Outlet} from "react-router-dom";

function Discord() {
    return (
        <Outlet />
    );
}

export default Discord;